module.exports = __webpack_public_path__ + "static/scale-model-of-bonanzaville-usa-in-fargo-north-dakota-9e5afab07392d0dad5724b7a33e27b13.png";